var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCagiWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106.957,
    height: 91.666,
    viewBox: "0 0 106.957 91.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 106.957,
    height: 91.666,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M25.167,116.441H15.509v15.616h9.658Zm-1.746,13.87H17.254V118.186h6.167Z",
    transform: "translate(-5.871 -44.077)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_71",
    "data-name": "Trac\\xE9 71",
    d: "M150.71,116.441h-9.654v15.616h9.654Zm-1.746,13.87H142.8V118.186h6.165Z",
    transform: "translate(-53.394 -44.077)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M25.168,81.742H15.509V93.675h9.659ZM23.421,91.93H17.254V83.485h6.167Z",
    transform: "translate(-5.871 -30.942)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M59.867,81.742H50.213V93.675h9.654ZM58.126,91.93H51.957V83.485h6.169Z",
    transform: "translate(-19.007 -30.942)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_74",
    "data-name": "Trac\\xE9 74",
    d: "M87.94,81.742H78.282V93.675H87.94ZM86.193,91.93H80.028V83.485h6.165Z",
    transform: "translate(-29.632 -30.942)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M116.425,81.742h-9.658V93.675h9.658ZM114.68,91.93h-6.167V83.485h6.167Z",
    transform: "translate(-40.415 -30.942)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M150.709,81.742h-9.656V93.675h9.656ZM148.963,91.93H142.8V83.485h6.167Z",
    transform: "translate(-53.393 -30.942)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_256",
    "data-name": "Groupe 256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_255",
    "data-name": "Groupe 255",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M55.043,110.961a4.825,4.825,0,0,0-4.83,4.819v14.2h9.656v-14.2a4.824,4.824,0,0,0-4.826-4.819m0,1.745a3.081,3.081,0,0,1,3.081,3.074v12.455H51.959V115.78a3.082,3.082,0,0,1,3.084-3.074",
    transform: "translate(-19.007 -42.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78",
    "data-name": "Trac\\xE9 78",
    d: "M111.184,110.961a4.825,4.825,0,0,0-4.83,4.819v14.2h9.656v-14.2a4.824,4.824,0,0,0-4.826-4.819m0,1.745a3.081,3.081,0,0,1,3.081,3.074v12.455H108.1V115.78a3.082,3.082,0,0,1,3.084-3.074",
    transform: "translate(-40.258 -42.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M105.216,111.363H82.576V68.029h22.641ZM1.742,68.029H24.385v43.335H1.742Zm12.414-3.476,11.331-2.84L36.5,61.438,19.294,66.3H7.213Zm39.321-6.094L81.24,66.289H25.718Zm28,3.364L99.65,66.3H87.664L70.876,61.554Zm-.631,49.543H26.12V68.029H80.844Zm.862-51.28-17.627-.454-10.6-2.984L43.3,59.521l-18.047.452L.028,66.289H0v46.819H106.958V66.289ZM53.478,90.4a4.829,4.829,0,0,0-4.83,4.819v14.2H58.31v-14.2A4.829,4.829,0,0,0,53.478,90.4m0,1.745a3.082,3.082,0,0,1,3.086,3.074v12.455H50.4V95.221a3.081,3.081,0,0,1,3.079-3.074",
    transform: "translate(0 -21.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M78.407,0C69.44,0,62.974,6.585,62.974,15.143c0,9.63,6.916,15.264,14.448,15.264a12.189,12.189,0,0,0,7.732-2.547h.086L85.2,29.092v.825H91.21V13.292H80.671v6.131h4.153v2.262a10.055,10.055,0,0,1-5.965,2.142c-4.566,0-8.434-3.333-8.434-8.928,0-4.364,2.508-8.313,8.684-8.313A11.7,11.7,0,0,1,86.266,9.3l3.458-5.389S85.935,0,78.407,0M44.881,7.2h.084s.66,3.212,1.2,5.068L47.8,17.99H42l1.687-5.724C44.224,10.41,44.881,7.2,44.881,7.2m4.608,16.544L51.3,29.92h7.407L48.707.49H41.14l-10,29.43h7.407l1.771-6.179ZM15.429,0C6.582,0,0,6.585,0,15.143c0,8.724,6.212,15.264,15.429,15.264a16.158,16.158,0,0,0,11.852-4.935l-3.7-5.268S20.2,23.826,15.76,23.826c-5.435,0-8.313-4.485-8.313-8.848,0-4.239,2.674-8.393,8.313-8.393,4.07,0,7.362,3,7.362,3l3.335-5.43S22.712,0,15.429,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 7.21,
    height: 29.428,
    transform: "translate(99.747 0.49)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCagiWhite);
export default __webpack_public_path__ + "static/media/logo-cagi-white.caff34b5a1973f20fb5671f8a1b3d0a3.svg";
export { ForwardRef as ReactComponent };